/* agmf-variant-pref.js — the swatch in front of them beats the colour we
   guessed they like.
   ─────────────────────────────────────────────────────────────────────────
   The feed already ranks by colour: `agmf-pref.js` reads the shopper's
   preferred colourway from the personalisation service and `blend()` deals
   matching content early. That preference is an OFFLINE answer - computed
   from what they have done before, and often nothing at all for a first
   visit.

   Meanwhile the shopper is standing on a product page with their finger on a
   swatch. Picking Multicam is the strongest statement of colour intent the
   site will ever get, and until now the feed ignored it completely: the
   product card's own deck jumped to that colour (heroVariantJump) and the
   feed below carried on showing whatever it had.

   WHAT THIS DOES. Turns `variant:change` into a colour and hands it to
   AGMFPref as a LIVE preference, which outranks the stored one for as long
   as that variant is selected. It decides no order itself - it answers
   "which colour are they looking at" and the feed asks.

   WHY THE NEXT LAP, NOT THIS ONE. The feed is an endless recycler and the
   shopper is mid-scroll. Re-dealing what is under their thumb would move a
   card they were reading - so the flow re-blends each lane when it builds
   the NEXT lap. They pick Multicam, they keep reading, and the feed comes
   back round in Multicam. Nothing jumps.

   WHERE THE COLOUR COMES FROM. The section already ships the product's
   options and variants inline as `[data-agmf-product-data]` - the same JSON
   heroVariantJump reads - so this needs no request and cannot disagree with
   the deck about which option is the colour.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.AGMFVariantPref) return;

  var COLOUR_OPTION = /colou?r|camo|pattern|finish|shade/i;

  function productData() {
    try {
      var el = document.querySelector('[data-agmf-product-data]');
      return el ? JSON.parse(el.textContent || '{}') : null;
    } catch (e) { return null; }
  }

  /* Which option is the colour one, by name - the same test Agilite Media
     uses to find the colour axis, so the two never disagree about what a
     colourway is. */
  function colourIndex(data) {
    var options = (data && data.options) || [];
    for (var i = 0; i < options.length; i++) {
      var name = String((options[i] && (options[i].name || options[i])) || '');
      if (COLOUR_OPTION.test(name)) return i;
    }
    return -1;
  }

  function colourOf(variant, at) {
    if (!variant || at < 0) return '';
    var options = variant.options || variant.option_values || [];
    return String(options[at] || '').trim();
  }

  var data = productData();
  var at = colourIndex(data);
  if (at < 0) return;              // a product with no colourway: nothing to say

  function announce(colour) {
    if (!window.AGMFPref || !window.AGMFPref.prefer) return;
    window.AGMFPref.prefer(colour ? [colour] : []);
    try {
      window.dispatchEvent(new CustomEvent('agmf:prefchanged', {
        detail: { colours: window.AGMFPref.colours(), from: 'variant' }
      }));
    } catch (e) { /* an old browser still gets the ranking, just not the event */ }
  }

  /* The variant the page OPENS on counts too: arriving on ?variant=… for the
     Multicam one is the same statement as picking it. */
  function opening() {
    if (!data) return null;
    var wanted = null;
    try {
      var q = new URLSearchParams(window.location.search).get('variant');
      if (q) wanted = String(q);
    } catch (e) { /* no URLSearchParams: fall back to the current variant */ }
    var variants = data.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (wanted && String(variants[i].id) === wanted) return variants[i];
    }
    return data.current || variants[0] || null;
  }

  var current = opening();
  if (current) announce(colourOf(current, at));

  document.addEventListener('variant:change', function (e) {
    var variant = (e && e.detail && (e.detail.variant || e.detail)) || null;
    // Some emitters send the whole variant, some only its id.
    if (variant && !variant.options && variant.id != null && data) {
      var variants = data.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(variant.id)) { variant = variants[i]; break; }
      }
    }
    var colour = colourOf(variant, at);
    if (colour) announce(colour);
  });

  window.AGMFVariantPref = {
    axis: function () { return at; },
    colour: function () {
      return window.AGMFPref && window.AGMFPref.colours ? window.AGMFPref.colours()[0] || '' : '';
    }
  };
}());
